module.exports = __webpack_public_path__ + "fonts/opensans-bolditalic-webfont.1169153.woff";